import React from "react";
import { ColumnConfig } from "grommet";
import { PermissionType } from "../types/PermissionType";

export const PermissionTableColumns: ColumnConfig<PermissionType>[] = [
  {
    property: "code",
    header: "Permission code",
    primary: true,
    render: (item) => {
      return <div style={{width:"50%"}} className="cell-container">{item.code}</div>;
    },
  },
  {
    property: "description",
    header: "Description",
    primary: true,
    render: (item) => {
      return <div  style={{width:"50%"}} className="cell-container">{item.description}</div>;
    },
  },
];
